import { type BasketLineViewModel } from 'autogen/swagger/all';
import styled from 'styled-components';
import { Price } from 'components/generic/productPrice';
import PriceWithDiscount from 'components/generic/productPrice/components/PriceWithDiscount';
import SubscriptionPrice from './components/SubscriptionPrice';

const StyledPrice = styled(Price)`
    text-decoration: line-through;
`;

export default function BasketPrice({ model }: { model: BasketLineViewModel }) {
    const {
        priceInfo: { subtotal, hasDiscount, subtotalBefore },
        subscriptionInfo,
        subscriptionNudge
    } = model;

    const isSubscriptionNudgeEnabled = subscriptionNudge?.isToggled;
    const isSubscriptionPurchase = subscriptionInfo && !isSubscriptionNudgeEnabled;

    if (isSubscriptionPurchase) return <SubscriptionPrice model={model} />;

    if (isSubscriptionNudgeEnabled) return <StyledPrice size={14} price={subtotalBefore} />;

    if (hasDiscount) {
        return <PriceWithDiscount size={14} price={subtotal} priceBefore={subtotalBefore} />;
    }

    return <Price size={14} price={subtotal} />;
}
